module.exports = __webpack_public_path__ + "img/20240625135255420jgl.39e02770.jpg";